import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, CardFooter } from "reactstrap";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

function ConnectInsuranceServiceDelete() {

  const [loading, setLoading] = useState(true)
  const [insurance, setInsurance] = useState([])

  const [submit, setSubmit]=useState(true)

  const { fieldId } = useParams();

  const navigate = useNavigate();

  const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
          
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/list-synchronization-user/`, config);

        console.log(response.data)

        setInsurance(response.data)

      } catch (error) {
          
        console.log(error)

      } finally {
        setLoading(false)
      }
    };

    fetchData(); 
  }, [token]);

  const SubmitDelete = async(e) => {

     setSubmit(false);

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        };

        await axios.delete(`${process.env.REACT_APP_BACKEND_API}/insurance/delete-synchronize-normal-user-insurance-profile/${fieldId}/`, config);

      } catch(error) {
        console.error(error);
      } finally {
        setSubmit(true); 
        navigate('/connect-insurance-service/')
      }
  }

  return (
    <div>
      <Header/>
      {loading ? (
        <Container className="mt--15" fluid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
              <Spinner>
                {t('Loading')}
              </Spinner>
            </Col>
          </Row>
        </Container>
      ):(
        <Container className="mt--15" fluid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
              <Card>
                <CardHeader>
                  <h3>{t('Are you sure to delete the link to the Insurance Operator?')}</h3>
                </CardHeader>
                <CardBody>
                  <lu>
                    <li>{t('Operator Name')} : {insurance.first_name_insurance_user}</li>
                    <li>{t('Operator Surname')} : {insurance.last_name_insurance_user}</li>
                    <li>{t('Operator Email')} : {insurance.email_insurance_user}</li>
                    <li>{t('Operator Accepted Your Request?')} : {insurance.is_accepted ? (<FaCheckCircle color="green" />) : (<FaTimesCircle color="red" />)}</li>
                    <li>{t('Request Send at')} : {format(new Date(insurance.created_at), 'PPpp')}</li>
                  </lu>
                </CardBody>
                <CardFooter>
                  <Row>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                      {submit ? (
                        <>
                          <Button color="danger" onClick={SubmitDelete}>
                            {t('Delete Insurance Operator Link')} <i className="fas fa-trash"></i>
                          </Button>
                        </>
                      ):(
                        <>
                          <Button color="danger" disabled>
                            <Spinner size="sm">
                            {t('Deleting...')}
                            </Spinner>
                            <span>
                              {' '}{t('Deleting')}
                            </span>
                          </Button>
                        </>
                      )}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                      <Link to="/connect-insurance-service/">
                        <Button color="primary">
                          {t('Go back')}<i className="fas fa-rotate-left"></i>
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  )
}

export default ConnectInsuranceServiceDelete
